import { TourTrackingProvider } from 'ui-shepherd-tracker/contexts/TourTrackingProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const OnboardingTourTrackingProvider = ({
  children
}) => {
  return /*#__PURE__*/_jsx(TourTrackingProvider, {
    appName: "onboarding-tours",
    children: children
  });
};